webpackJsonp([271],{

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckStatsTable_vue__ = __webpack_require__(2517);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b81491c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckStatsTable_vue__ = __webpack_require__(3187);
function injectStyle (ssrContext) {
  __webpack_require__(3183)
  __webpack_require__(3185)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b81491c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckStatsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b81491c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckStatsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 2517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__ = __webpack_require__(1347);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {
      searchExpanded: true,
      listExpanded: true,
      search: {
        projectid: null,
        updated_at: []
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      searchFieldType: {
        projectid: String,
        updated_at: Array
      },
      resetLlmDialogVisible: false,
      resetLlmProjectId: null,
      resetLlmSubmitting: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail']), {
    getProjectTableQuery: function getProjectTableQuery(params) {
      return this.getProjectTable(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        current_page: 1,
        per_page: 20
      }, params || {}));
    },
    getTableData: function getTableData(params) {
      return request.page('queryAudioAsrCheckProjectStats', params);
    },
    openResetLlmDialog: function openResetLlmDialog(projectid) {
      this.resetLlmProjectId = projectid || this.search.projectid || null;
      this.resetLlmDialogVisible = true;
    },
    submitResetLlmDialog: function submitResetLlmDialog() {
      var _this = this;

      if (!this.resetLlmProjectId) {
        this.$message.warning('请选择项目');
        return;
      }
      this.confirmResetLlm(this.resetLlmProjectId, '').then(function () {
        _this.resetLlmDialogVisible = false;
      }).catch(function () {});
    },
    onResetLlm: function onResetLlm(row) {
      if (!row || !row.projectid) {
        this.$message.warning('缺少项目ID');
        return;
      }
      var name = row.project_name ? '\u300C' + row.project_name + '\u300D' : '';
      this.confirmResetLlm(row.projectid, name).catch(function () {});
    },
    confirmResetLlm: function confirmResetLlm(projectid, projectNameLabel) {
      var _this2 = this;

      var label = projectNameLabel || '\u9879\u76EE ' + projectid;
      return this.$confirm('\u786E\u8BA4\u5C06' + label + '\u4E0B\u6210\u529F\u548C\u5931\u8D25\u7684\u5DE5\u5355\u91CD\u65B0\u6392\u961F\u68C0\u6D4B\u98CE\u9669\uFF1FASR \u5931\u8D25\u4F1A\u91CD\u65B0 ASR\uFF0C\u5176\u4F59\u4EC5\u91CD\u8DD1 LLM\uFF1B\u7528\u91CF\u5728\u539F\u503C\u4E0A\u7D2F\u52A0\u3002', '重新检测风险', { type: 'warning' }).then(function () {
        _this2.resetLlmSubmitting = true;
        return request.common('resetAudioAsrCheckProjectLlm', { projectid: projectid }).then(function (_ref) {
          var data = _ref.data;

          var affected = data && data.affected != null ? data.affected : 0;
          _this2.$message.success('\u5DF2\u91CD\u7F6E ' + affected + ' \u6761\u5DE5\u5355\uFF0C\u7B49\u5F85\u5B9A\u65F6\u4EFB\u52A1\u91CD\u65B0\u68C0\u6D4B\u98CE\u9669');
          _this2.onRefresh();
        });
      }).finally(function () {
        _this2.resetLlmSubmitting = false;
      });
    },
    onExportSearch: function onExportSearch() {
      var exportParams = Object(__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["c" /* removeEmptyParams */])(_.cloneDeep(this.lastSeachParams || {}));
      delete exportParams.current_page;
      delete exportParams.per_page;
      delete exportParams[''];
      this.$export(this.$route.meta.title + '_\u641C\u7D22\u7ED3\u679C', {
        fileHeader: [{ key: 'projectid', text: '项目ID' }, { key: 'project_name', text: '项目名称' }, { key: 'checked_order_count', text: '已检查工单数' }, { key: 'trigger_risk_order_count', text: '风险工单数' }, { key: 'risk_rate_text', text: '风险率' }, { key: 'total_record_asr_minutes', text: 'ASR时长(分钟)' }, { key: 'total_llm_tokens', text: 'LLM Token' }, { key: 'updated_at', text: '更新时间' }],
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: exportParams
      });
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    }
  })
});

/***/ }),

/***/ 3183:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("8902f51a", content, true, {});

/***/ }),

/***/ 3184:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-check-stats-table__card[data-v-6b81491c]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.asr-check-stats-table__card+.asr-check-stats-table__card[data-v-6b81491c]{margin-top:16px}.asr-check-stats-table__card-header[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.asr-check-stats-table__card-header i[data-v-6b81491c]{color:#909399}.asr-check-stats-table__card-header-actions[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.asr-check-stats-table__card-header-actions ::v-deep .asr-check-stats-table__header-action.el-button[data-v-6b81491c]{min-width:24px;padding:0;margin:0}.asr-check-stats-table__header-action[data-v-6b81491c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1}.asr-check-stats-table__header-action i[data-v-6b81491c]{font-size:14px}.asr-check-stats-table__search-form[data-v-6b81491c]{padding:16px 24px 20px}.asr-check-stats-table__search-grid[data-v-6b81491c]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px}.asr-check-stats-table__search-actions[data-v-6b81491c]{margin-top:16px;padding-top:4px}.asr-check-stats-table__list-body[data-v-6b81491c]{padding:16px}.asr-check-stats-table__toolbar[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;gap:12px;padding:0 0 16px}.asr-check-stats-table__table-wrap[data-v-6b81491c]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden;margin-top:0}.asr-check-stats-table__table-wrap ::v-deep .el-table[data-v-6b81491c]:after,.asr-check-stats-table__table-wrap ::v-deep .el-table[data-v-6b81491c]:before{display:none}.asr-check-stats-table__table-wrap ::v-deep .el-table__body tr:last-child td[data-v-6b81491c]{border-bottom:none}.asr-check-stats-table__table ::v-deep th[data-v-6b81491c]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500}.asr-check-stats-table__table ::v-deep td[data-v-6b81491c]{font-size:14px;color:#303133}.asr-check-stats-table__table ::v-deep .el-table__row:hover>td[data-v-6b81491c]{background:#fafafa}.asr-check-stats-table__risk-count[data-v-6b81491c]{color:#dc2626;font-weight:500}.asr-check-stats-table__actions[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;padding:4px 0}.asr-check-stats-table__action[data-v-6b81491c]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;background:#fff;cursor:pointer;-webkit-transition:background-color .15s ease;transition:background-color .15s ease;outline:none;font-family:inherit;text-decoration:none}.asr-check-stats-table__action.is-view[data-v-6b81491c]{color:#606266;border:1px solid #909399}.asr-check-stats-table__action.is-reset[data-v-6b81491c]{color:#e6a23c;border:1px solid #e6a23c}.asr-check-stats-table__action[data-v-6b81491c]:hover{background:#f9fafb}.asr-check-stats-table__reset-tip[data-v-6b81491c]{margin:0 0 16px;font-size:13px;color:#606266;line-height:1.6}.asr-check-stats-table .pagination[data-v-6b81491c]{margin:16px auto 0;text-align:center}@media (max-width:1200px){.asr-check-stats-table__search-grid[data-v-6b81491c]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.asr-check-stats-table__search-grid[data-v-6b81491c]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/audio-asr-check/pages/AudioAsrCheckStatsTable.vue"],"names":[],"mappings":"AACA,8CAA8C,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CAClL,AACD,2EAA2E,eAAe,CACzF,AACD,qDAAqD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CAC1b,AACD,uDAAuD,aAAa,CACnE,AACD,6DAA6D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CAC1L,AACD,sHAAsH,eAAe,UAAU,QAAQ,CACtJ,AACD,uDAAuD,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,UAAU,SAAS,cAAc,oBAAoB,cAAc,aAAa,CAC7W,AACD,yDAAyD,cAAc,CACtE,AACD,qDAAqD,sBAAsB,CAC1E,AACD,qDAAqD,aAAa,8CAAgD,aAAa,CAC9H,AACD,wDAAwD,gBAAgB,eAAe,CACtF,AACD,mDAAmD,YAAY,CAC9D,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,uBAAuB,oBAAoB,2BAA2B,SAAS,gBAAgB,CACtQ,AACD,oDAAoD,yBAAyB,kBAAkB,gBAAgB,YAAY,CAC1H,AACD,2JAA6J,YAAY,CACxK,AACD,8FAA8F,kBAAkB,CAC/G,AACD,2DAA2D,mBAAmB,cAAc,eAAe,eAAe,CACzH,AACD,2DAA2D,eAAe,aAAa,CACtF,AACD,gFAAgF,kBAAkB,CACjG,AACD,oDAAoD,cAAc,eAAe,CAChF,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,aAAa,CAC5J,AACD,gDAAgD,qBAAqB,iBAAiB,kBAAkB,eAAe,iBAAiB,gBAAgB,gBAAgB,eAAe,8CAA+C,sCAAuC,aAAa,oBAAoB,oBAAoB,CACjU,AACD,wDAAwD,cAAc,wBAAwB,CAC7F,AACD,yDAAyD,cAAc,wBAAwB,CAC9F,AACD,sDAAsD,kBAAkB,CACvE,AACD,mDAAmD,gBAAgB,eAAe,cAAc,eAAe,CAC9G,AACD,oDAAoD,mBAAmB,iBAAiB,CACvF,AACD,0BACA,qDAAqD,6CAA+C,CACnG,CACA,AACD,yBACA,qDAAqD,yBAAyB,CAC7E,CACA","file":"AudioAsrCheckStatsTable.vue","sourcesContent":["\n.asr-check-stats-table__card[data-v-6b81491c]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.asr-check-stats-table__card+.asr-check-stats-table__card[data-v-6b81491c]{margin-top:16px\n}\n.asr-check-stats-table__card-header[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.asr-check-stats-table__card-header i[data-v-6b81491c]{color:#909399\n}\n.asr-check-stats-table__card-header-actions[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.asr-check-stats-table__card-header-actions ::v-deep .asr-check-stats-table__header-action.el-button[data-v-6b81491c]{min-width:24px;padding:0;margin:0\n}\n.asr-check-stats-table__header-action[data-v-6b81491c]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1\n}\n.asr-check-stats-table__header-action i[data-v-6b81491c]{font-size:14px\n}\n.asr-check-stats-table__search-form[data-v-6b81491c]{padding:16px 24px 20px\n}\n.asr-check-stats-table__search-grid[data-v-6b81491c]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px 16px\n}\n.asr-check-stats-table__search-actions[data-v-6b81491c]{margin-top:16px;padding-top:4px\n}\n.asr-check-stats-table__list-body[data-v-6b81491c]{padding:16px\n}\n.asr-check-stats-table__toolbar[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;gap:12px;padding:0 0 16px\n}\n.asr-check-stats-table__table-wrap[data-v-6b81491c]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden;margin-top:0\n}\n.asr-check-stats-table__table-wrap ::v-deep .el-table[data-v-6b81491c]::before,.asr-check-stats-table__table-wrap ::v-deep .el-table[data-v-6b81491c]::after{display:none\n}\n.asr-check-stats-table__table-wrap ::v-deep .el-table__body tr:last-child td[data-v-6b81491c]{border-bottom:none\n}\n.asr-check-stats-table__table ::v-deep th[data-v-6b81491c]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500\n}\n.asr-check-stats-table__table ::v-deep td[data-v-6b81491c]{font-size:14px;color:#303133\n}\n.asr-check-stats-table__table ::v-deep .el-table__row:hover>td[data-v-6b81491c]{background:#fafafa\n}\n.asr-check-stats-table__risk-count[data-v-6b81491c]{color:#dc2626;font-weight:500\n}\n.asr-check-stats-table__actions[data-v-6b81491c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;padding:4px 0\n}\n.asr-check-stats-table__action[data-v-6b81491c]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;background:#fff;cursor:pointer;-webkit-transition:background-color 0.15s ease;transition:background-color 0.15s ease;outline:none;font-family:inherit;text-decoration:none\n}\n.asr-check-stats-table__action.is-view[data-v-6b81491c]{color:#606266;border:1px solid #909399\n}\n.asr-check-stats-table__action.is-reset[data-v-6b81491c]{color:#e6a23c;border:1px solid #e6a23c\n}\n.asr-check-stats-table__action[data-v-6b81491c]:hover{background:#f9fafb\n}\n.asr-check-stats-table__reset-tip[data-v-6b81491c]{margin:0 0 16px;font-size:13px;color:#606266;line-height:1.6\n}\n.asr-check-stats-table .pagination[data-v-6b81491c]{margin:16px auto 0;text-align:center\n}\n@media (max-width: 1200px){\n.asr-check-stats-table__search-grid[data-v-6b81491c]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.asr-check-stats-table__search-grid[data-v-6b81491c]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3185:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3186);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a7eece66", content, true, {});

/***/ }),

/***/ 3186:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-check-stats-table__search-form .el-form-item{margin-bottom:0}.asr-check-stats-table__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px}", "", {"version":3,"sources":["/workspace/src/views/audio-asr-check/pages/AudioAsrCheckStatsTable.vue"],"names":[],"mappings":"AACA,kDAAkD,eAAe,CAChE,AACD,yDAAyD,cAAc,eAAe,gBAAgB,CACrG","file":"AudioAsrCheckStatsTable.vue","sourcesContent":["\n.asr-check-stats-table__search-form .el-form-item{margin-bottom:0\n}\n.asr-check-stats-table__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"asr-check-stats-table"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("录音风险管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("录音风险项目统计")])],1)],1),_vm._v(" "),_c('div',{staticClass:"asr-check-stats-table__card asr-check-stats-table__card--search"},[_c('div',{staticClass:"asr-check-stats-table__card-header",on:{"click":function($event){_vm.searchExpanded = !_vm.searchExpanded}}},[_c('span',[_vm._v("搜索")]),_vm._v(" "),_c('i',{class:_vm.searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchExpanded),expression:"searchExpanded"}],ref:"searchForm",staticClass:"asr-check-stats-table__search-form",attrs:{"model":_vm.search,"label-width":"96px","label-position":"left","size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"asr-check-stats-table__search-grid"},[_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择项目","query-request":_vm.getProjectTableQuery,"find-request":_vm.getProjectDetail},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"更新时间","prop":"updated_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.updated_at),callback:function ($$v) {_vm.$set(_vm.search, "updated_at", $$v)},expression:"search.updated_at"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"asr-check-stats-table__search-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"asr-check-stats-table__card"},[_c('div',{staticClass:"asr-check-stats-table__card-header",on:{"click":function($event){_vm.listExpanded = !_vm.listExpanded}}},[_c('span',[_vm._v("列表")]),_vm._v(" "),_c('div',{staticClass:"asr-check-stats-table__card-header-actions"},[_c('el-button',{staticClass:"asr-check-stats-table__header-action",attrs:{"type":"text","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh()}}}),_vm._v(" "),_c('span',{staticClass:"asr-check-stats-table__header-action"},[_c('i',{class:_vm.listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listExpanded),expression:"listExpanded"}],staticClass:"asr-check-stats-table__list-body"},[_c('div',{staticClass:"asr-check-stats-table__toolbar"},[_c('el-button',{attrs:{"type":"success","size":"small","icon":"sj-icon-export"},on:{"click":_vm.onExportSearch}},[_vm._v("按搜索结果导出")])],1),_vm._v(" "),_c('div',{staticClass:"asr-check-stats-table__table-wrap"},[_c('el-table',{staticClass:"asr-check-stats-table__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_c('el-table-column',{attrs:{"prop":"projectid","label":"项目ID","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"project_name","label":"项目名称","min-width":"180","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.project_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"checked_order_count","label":"已检查工单数","width":"120","align":"right"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trigger_risk_order_count","label":"风险工单数","width":"110","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{class:{ 'asr-check-stats-table__risk-count': Number(scope.row.trigger_risk_order_count) > 0 }},[_vm._v("\n                "+_vm._s(scope.row.trigger_risk_order_count)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"risk_rate_text","label":"风险率","width":"90","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.risk_rate_text || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_record_asr_minutes","label":"ASR时长(分钟)","width":"130","align":"right"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_llm_tokens","label":"LLM Token","min-width":"120","align":"right"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"更新时间","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.updated_at || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"200","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"asr-check-stats-table__actions"},[_c('router-link',{staticClass:"asr-check-stats-table__action is-view",attrs:{"to":{ path: '/audio-asr-check/result', query: { projectid: scope.row.projectid } }}},[_vm._v("\n                  查看风险\n                ")]),_vm._v(" "),_c('a',{staticClass:"asr-check-stats-table__action is-reset",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();return _vm.onResetLlm(scope.row)}}},[_vm._v("\n                  重新检测风险\n                ")])],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"按项目重新检测风险","visible":_vm.resetLlmDialogVisible,"width":"480px","append-to-body":""},on:{"update:visible":function($event){_vm.resetLlmDialogVisible=$event}}},[_c('p',{staticClass:"asr-check-stats-table__reset-tip"},[_vm._v("\n      将把该项目下「成功 / 失败」工单重新排队：ASR 失败会重新 ASR，其余仅重跑 LLM；由定时任务执行。用量（ASR 分钟 / LLM Token）会在原值上累加，不会清零。\n    ")]),_vm._v(" "),_c('el-form',{attrs:{"label-width":"80px","size":"small"}},[_c('el-form-item',{attrs:{"label":"项目","required":""}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择项目","query-request":_vm.getProjectTableQuery,"find-request":_vm.getProjectDetail},model:{value:(_vm.resetLlmProjectId),callback:function ($$v) {_vm.resetLlmProjectId=$$v},expression:"resetLlmProjectId"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.resetLlmDialogVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","loading":_vm.resetLlmSubmitting},on:{"click":_vm.submitResetLlmDialog}},[_vm._v("确定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audio-asr-check-stats.23b02ce8f28acf110fcf.js